import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    messages: [],
    user: null,
  },

  mutations: {
    // Add new message
    addMessage (state, message) { state.messages.push(message); },

    // Remove all messages
    removeMessages (state) { state.messages = []; },

    // Save user info
    setUserInfo (state, user) { state.user = user; },
  },

  getters: {
    // Return last generic error
    messages: state => state.messages,

    // Return logged user id
    userInfo: state => state.user,
  }
})